import React, { useEffect } from "react";
import "./css/cursortrail.module.css"; // Add CSS file for styling

const CursorTrail = () => {
  useEffect(() => {
    const editCursor = (e) => {
      const cursor = document.querySelector(".cursor");
      const { clientX: x, clientY: y } = e;
      cursor.style.left = x + "px";
      cursor.style.top = y + "px";
    };

    window.addEventListener("mousemove", editCursor);

    return () => {
      window.removeEventListener("mousemove", editCursor);
    };
  }, []);

  return <div className="cursor"></div>;
};

export default CursorTrail;
